/* Copyright 2013 - 2022 Waiterio LLC */
export default function () {
  return {
    data: {},
    pages: {},
  }
}
